/**
 * @author Fernando FH
 */
import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class ImageHistoryService extends MainService {

  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.IMAGE_HISTORY_LITS_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_BY_ID, params);
  }
  static getImagebyStudy(params) {
    return this.postSEC(ServicePath.STUDY_FIND_ALL_IMAGES_BY_STUDY, params);
  }
  static update(params) {
    return this.postSEC(ServicePath.INTERPRETATION_UPDATE, params);
  }
  static getAddendums(params) {
    return this.postSEC(ServicePath.INTERPRETATION_GET_ADDENDUMS, params);
  }
  
  static downloadReportHistoryXLSX(params) {
    return this.postPDFSEC(ServiceConstant.INTERPRETATION_REPORT_HISTORY_XLSX, params);
  }

}